import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { LanguageService } from '../../../../framework/services/language.service';
import { AddEngagementMemoryService } from '../../add-engagement-memory-service/add-engagement-memory.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { element } from 'protractor';
//import { ThrowStmt } from '@angular/compiler';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';


@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.css']
})
export class LanguageComponent implements OnInit {

  languageList = [];
  selectedLanguages: any[] = [];
  selectedLanguageId: number;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;
  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;
  languageControl: FormControl;
  @Output() showNextControl = new EventEmitter<string>()

  constructor(private languageService: LanguageService,
    private addEngagementMemoryService: AddEngagementMemoryService,
    private ngxSpinner: NgxSpinnerService) {
    this.languageControl = new FormControl(this.selectedLanguages, this.languageRequired())
  }
  ngOnInit(): void {
    this.ngxSpinner.show();
    this.loadLanguageLabel();
    this.selectedLanguages = this.languageList;
    if (this.addEngagementMemoryService.getSelectedLanguages()?.length > 0) {      
      this.selectedLanguages = this.addEngagementMemoryService.getSelectedLanguages();
      this.ngxSpinner.hide();
    }
    if (this.selectedLanguages.length == 0 && this.addEngagementMemoryService.getEngagementId() > 0) {
      this.languageService.getEngagementSelectedLanguages(this.addEngagementMemoryService.getEngagementId()).subscribe((response) => {
        this.selectedLanguages = response.data;
        if (this.selectedLanguages.findIndex(t => t.name == "English") > -1)
          this.resetLanguageRoles(true);
        else
          this.resetLanguageRoles(false);
        this.ngxSpinner.hide();
      })
    }
   
  }

  resetLanguageRoles(isEnglishSelected: boolean) {
    let eyRoles = this.addEngagementMemoryService.getLanguageBasedRoles();
    if (eyRoles && eyRoles.length > 0) {
      let roles = isEnglishSelected ? eyRoles.find(t => t.languageName == "English")?.engagementRoleModels : eyRoles.find(t => t.languageName == "French")?.engagementRoleModels;
      eyRoles.forEach(element => {
        if (element.engagementRoleModels == null || element.engagementRoleModels.length == 0) {
          element.engagementRoleModels = roles
        }
      })
    }
  }

  languageReplacer(labelKey) {
    var labels = this.selectedLangLabelJson[labelKey]?.trim() ? this.selectedLangLabelJson[labelKey] ?? 'text not found' : this.defaultEngLangLabelJson[labelKey] ?? 'text not found';
    return labels;
  }

  getLanguages() {
    this.languageList = new Array<any>();
    var languages = this.addEngagementMemoryService.getLanguages();
    languages.forEach(item => {
      item.name = this.languageReplacer(item.name);
    })
    this.languageList = languages;
    this.islabelLoaded = true;
  }



  onNextButtonClicked() {
    if (!this.languageControl.invalid) {

      this.ngxSpinner.show();
      this.languageService.getAllLanguages().subscribe((response:any) => {
        if (response && response.length > 0) {
          let actualLanguages=[];
          this.selectedLanguages.forEach(ele => {
            actualLanguages.push(response.find(t => t.languageId == ele.languageId));
          });
          this.addEngagementMemoryService.setSelectedLanguages(this.selectedLanguages);
          this.addEngagementMemoryService.setActualLanguageSelected(actualLanguages);
          this.ngxSpinner.hide();
          this.showNextControl.emit("basicDetails");
        
        }
      })
    } else {
      this.languageControl.markAsTouched();
    }
  }



  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishLangLabelMappings, selectedLangLabelMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        this.islabelLoaded = false;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangLabelMappings = englishLangLabelMappings;
            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);
          this.getLanguages()

          resolve(1);
        }
        else {
        }
      });
    })
      .catch(err => {

        console.log(err);
      });
  }


  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }


  languageRequired(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched && control.value) {
        if (control.value.length > 0) {
          return null;
        }
      } else if (control.value && control.value.length > 0) {
        return null;
      }
      return { 'languageRequired': 'Language is required' };
    }
  }


}
